export function getDownloadLink() {
  if (typeof navigator === "undefined") {
    // Renderização no servidor: fallback genérico
    return "https://member.walrus.com";
  }

  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

  const isAndroid = /android/i.test(ua);
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;

  if (isAndroid) {
    return "https://play.google.com/store/apps/details?id=com.walrus.member";
  }

  if (isIOS) {
    return "https://apps.apple.com/us/app/walrus-health/id1480276838";
  }

  // Desktop ou plataforma desconhecida
  return "https://member.walrus.com";
}
